module.exports = __webpack_public_path__ + "static/media/logo-desktop.5aff68a7.png";